import { takeLatest, takeEvery, put, select } from "redux-saga/effects";
import { lower } from "change-case";

import { createReducer, makeAction, makeKeys } from "./helper";
import { httpPost, httpGet, httpDelete, httpPut } from "../core/restClient";
import { appLoading, appLoaded, toastError, toastSuccess } from "./app";
import { getHrmsMembers, getAllMembers } from "./member";
import { fetchGoas } from "./goa";
import {
  getVendors,
  getPurchasingGroups,
  getCompanies,
  fetchPMUsers,
  fetchProjects,
} from "./options";
import {
  goodsServiceReceiptDetailPath,
  goodsServiceReceiptEditPath,
  goodsServiceReceiptPath,
  homePath,
} from "routes";
import r from "reactotron-react-js";

const FETCH_GR = makeKeys("FETCH_GR");
const FETCH_GR_TYPE = makeKeys("FETCH_GR_TYPE");
const GET_GR_DETAIL = makeKeys("GET_GR_DETAIL");
const GET_GR_DETAIL_EDIT = makeKeys("GET_GR_DETAIL_EDIT");
const INITIALIZE_GR = "INITIALIZE_GR";
const GET_PM_USER_LIST = makeKeys("GET_PM_USER_LIST");
const CLEAR_GR_DETAIL = "CLEAR_GR_DETAIL";
const FETCH_PO_RELEASE = makeKeys("FETCH_PO_RELEASE");
const GET_PO_RELEASE_DETAIL = makeKeys("GET_PO_RELEASE_DETAIL");
const FETCH_GR_PAYMENT_TYPE = makeKeys("FETCH_GR_PAYMENT_TYPE");
const FILTER_ITEM_PO_RELEASE = "FILTER_ITEM_PO_RELEASE";
const REMOVE_ITEM_PO_RELEASE = "REMOVE_ITEM_PO_RELEASE";
const ADD_ITEM_PO_RELEASE = "ADD_ITEM_PO_RELEASE";
const RESET_ITEM_PO_RELEASE = "RESET_ITEM_PO_RELEASE";
const CREATE_GR = "CREATE_GR";
const UPDATE_GR = "UPDATE_GR";
const DELETE_GR = "DELETE_GR";
const SAVE_GR_ATTACHEMNTS = "SAVE_GR_ATTACHEMNTS";
const SUBMIT_GR = "SUBMIT_GR";
const RESUBMIT_GR = "RESUBMIT_GR";
const CANCEL_GR = "CANCEL_GR";
const CALL_GR_ACTION = "CALL_GR_ACTION";
const GET_SPECIALAPPROVAL_INFO = makeKeys("GET_SPECIALAPPROVAL_INFO");
const GET_GR_ERROR_WORKFLOW = makeKeys("GET_GR_ERROR_WORKFLOW");
const GET_GR_GOA_WORK_FLOW_VIEW_MODE = makeKeys(
  "GET_GR_GOA_WORK_FLOW_VIEW_MODE",
);
const GET_GR_GOA_WORK_FLOW_EDIT_MODE = makeKeys(
  "GET_GR_GOA_WORK_FLOW_EDIT_MODE",
);
const GR_CHECK_DUPLICATE_INVOICE = makeKeys("GR_CHECK_DUPLICATE_INVOICE");
const CLEAR_CHECK_DUPLICATE_INVOICE = "CLEAR_CHECK_DUPLICATE_INVOICE";
const GET_GR_REPORT = makeKeys("GET_GR_REPORT");
const ADD_GR_SPECIAL_COMMENT = "ADD_GR_SPECIAL_COMMENT";
const GET_GR_DETAIL_BY_DOCNO = makeKeys("GET_GR_DETAIL_BY_DOCNO");

export const initializeGR = makeAction(INITIALIZE_GR, "isDetail");
export const fetchGRList = makeAction(FETCH_GR.REQUEST, "dataSearch");
export const fetchGRType = makeAction(FETCH_GR_TYPE.REQUEST);
export const fetchGRPaymentType = makeAction(FETCH_GR_PAYMENT_TYPE.REQUEST);
export const getGRDetail = makeAction(
  GET_GR_DETAIL.REQUEST,
  "grId",
  "history",
  "isRefresh",
);
export const getGRDetailEdit = makeAction(
  GET_GR_DETAIL_EDIT.REQUEST,
  "grId",
  "history",
);
export const getPMUserList = makeAction(GET_PM_USER_LIST.REQUEST, "grId");
export const clearGRDetail = makeAction(CLEAR_GR_DETAIL);
export const fetchPORelease = makeAction(FETCH_PO_RELEASE.REQUEST, "data");
export const getPOReleaseDetail = makeAction(
  GET_PO_RELEASE_DETAIL.REQUEST,
  "poSapNum",
  "grId",
);
export const filterItemPORelease = makeAction(
  FILTER_ITEM_PO_RELEASE,
  "poSapNum",
);
export const removeItemPORelease = makeAction(
  REMOVE_ITEM_PO_RELEASE,
  "poSapNum",
);
export const addItemPORelease = makeAction(ADD_ITEM_PO_RELEASE, "poSapNum");
export const resetItemPORelease = makeAction(RESET_ITEM_PO_RELEASE);
export const createGR = makeAction(CREATE_GR, "data", "history", "isSubmit");
export const updateGR = makeAction(UPDATE_GR, "data", "history", "isSubmit");
export const saveGRAttachments = makeAction(
  SAVE_GR_ATTACHEMNTS,
  "data",
  "history",
  "isSubmit",
  "isCreate",
);
export const submitGR = makeAction(SUBMIT_GR, "data", "history");
export const resubmitGR = makeAction(RESUBMIT_GR, "data", "history");
export const cancelGR = makeAction(CANCEL_GR, "data", "history");
export const deleteGR = makeAction(DELETE_GR, "data", "history");
export const callGRAction = makeAction(CALL_GR_ACTION, "data", "history");
export const getSpecialApprovalInfo = makeAction(
  GET_SPECIALAPPROVAL_INFO.REQUEST,
  "id",
);
export const getGRErrorWorkFlow = makeAction(
  GET_GR_ERROR_WORKFLOW.REQUEST,
  "procInstID",
  "subProcInstID",
);
export const getGRGOAWorkFlowViewMode = makeAction(
  GET_GR_GOA_WORK_FLOW_VIEW_MODE.REQUEST,
  "grId",
);
export const getGRGOAWorkFlowEditMode = makeAction(
  GET_GR_GOA_WORK_FLOW_EDIT_MODE.REQUEST,
  "data",
);
export const checkDuplicateInvoice = makeAction(
  GR_CHECK_DUPLICATE_INVOICE.REQUEST,
  "data",
  "history",
  "isSubmit",
);
export const clearCheckDuplicateInvoice = makeAction(
  CLEAR_CHECK_DUPLICATE_INVOICE,
);
export const getGRReport = makeAction(
  GET_GR_REPORT.REQUEST,
  "dateS",
  "dateE",
  "companyCode",
  "key",
);
export const addSpecialComment = makeAction(
  ADD_GR_SPECIAL_COMMENT,
  "id",
  "data",
  "history",
);
export const getGRDetailByDocNo = makeAction(
  GET_GR_DETAIL_BY_DOCNO.REQUEST,
  "grId",
);

const fetchGRListSuccess = makeAction(FETCH_GR.SUCCESS, "data");
const fetchGRTypeSuccess = makeAction(FETCH_GR_TYPE.SUCCESS, "data");
const fetchGRPaymentTypeSuccess = makeAction(
  FETCH_GR_PAYMENT_TYPE.SUCCESS,
  "data",
);
const fetchPOReleaseSuccess = makeAction(FETCH_PO_RELEASE.SUCCESS, "data");
const getPOReleaseDetailSuccess = makeAction(
  GET_PO_RELEASE_DETAIL.SUCCESS,
  "data",
);
const getGRDetailSuccess = makeAction(GET_GR_DETAIL.SUCCESS, "data");
const getGRDetailEditSuccess = makeAction(GET_GR_DETAIL_EDIT.SUCCESS, "data");
const getPMUserListSuccess = makeAction(GET_PM_USER_LIST.SUCCESS, "data");
const getGRGOAWorkFlowViewModeSuccess = makeAction(
  GET_GR_GOA_WORK_FLOW_VIEW_MODE.SUCCESS,
  "data",
);
const getGRGOAWorkFlowEditModeSuccess = makeAction(
  GET_GR_GOA_WORK_FLOW_EDIT_MODE.SUCCESS,
  "data",
);
const getGRErrorWorkFlowSuccess = makeAction(
  GET_GR_ERROR_WORKFLOW.SUCCESS,
  "data",
);
const getSpecialApprovalInfoSuccess = makeAction(
  GET_SPECIALAPPROVAL_INFO.SUCCESS,
  "data",
);
const checkDuplicateInvoiceSuccess = makeAction(
  GR_CHECK_DUPLICATE_INVOICE.SUCCESS,
  "data",
);
const getGRReportSuccess = makeAction(GET_GR_REPORT.SUCCESS, "data");
const getGRDetailByDocNoSuccess = makeAction(
  GET_GR_DETAIL_BY_DOCNO.SUCCESS,
  "data",
);

const multipartHeader = { "Content-Type": "multipart/form-data" };

const initial = {
  grList: {},
  grDetail: { data: {}, loaded: false },
  grType: { data: [], loading: false },
  grPaymentType: { data: [], loading: false },
  k2workFlowError: { isError: false, msg: "" },
  goaWorkFlow: { data: [], loading: false },
  poReleaseList: { buffer: [], data: [], loading: false },
  poReleaseDetail: null,
  specialApprovalInfo: { data: {}, loading: false },
  grReportList: { data: [], loading: false },
  invDuplicate: null,
};

function* initializeGRRequest(action) {
  const { isDetail } = action.payload;
  try {
    const state = yield select();
    if (!state.goa.goas.length) {
      yield put(fetchGoas());
    }
    // yield put(getHrmsMembers(isDetail))
    yield put(getAllMembers(isDetail));
    if (!state.options.vendors.length) {
      yield put(getVendors());
    }
    if (!state.options.companies.data.length) {
      yield put(getCompanies());
    }
    if (!state.options.purchasingGroups.data.length) {
      yield put(getPurchasingGroups());
    }
    if (!state.options.pmUsers.data.length) {
      yield put(fetchPMUsers());
    }
    if (!state.gr.grPaymentType.data.length) {
      yield put(fetchGRPaymentType());
    }
    if (!state.gr.grType.data.length) {
      yield put(fetchGRType());
    }
    // if(!state.options.projects.data.length){
    //   yield put(fetchProjects())
    // }
  } catch (e) {
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    console.log(e);
  }
}

function* getSpecialApprovalInfoRequest(action) {
  const { id } = action.payload;
  try {
    const response = yield httpGet(`goas/specialApproval/${id}`);
    if (response.status >= 200 && response.status < 300) {
      yield put(getSpecialApprovalInfoSuccess(response.data));
    }
  } catch (e) {
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getSpecialApprovalInfo(id));
    } else {
      yield put(getSpecialApprovalInfoSuccess({}));
    }
  }
}

function* fetchGRTypeRequest() {
  try {
    const response = yield httpGet("goodsservicereceipt/GetDeliveryType");
    if (response.status >= 200 && response.status < 300) {
      let index = response.data.findIndex(
        (x) => x.mainDeliveryType.toLowerCase() == "service",
      );
      response.data[index].subDeliveryTypes.forEach((x) =>
        x.attachmentGroup.splice(1, 0, {
          name: "เอกสารส่งมอบงานที่ Vendor ลงนาม",
          code: "GR04",
          isRequire: true,
          isAdditional: false,
        }),
      );
      yield put(fetchGRTypeSuccess(response.data));
    }
  } catch (e) {
    yield put(fetchGRTypeSuccess([]));
  }
}

function* fetchGRPaymentTypeRequest() {
  try {
    const response = yield httpGet("options/getPaymentType/gr");
    if (response.status >= 200 && response.status < 300) {
      yield put(
        fetchGRPaymentTypeSuccess(
          response.data.map((m) => ({
            value: lower(m.code),
            text: m.name,
          })),
        ),
      );
    }
  } catch (e) {
    yield put(fetchGRPaymentTypeSuccess([]));
  }
}

function* fetchGRListRequest(action) {
  const { dataSearch } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpGet("goodsservicereceipt", dataSearch);
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchGRListSuccess(response.data));
    }
    yield put(appLoaded());
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(fetchGRList(dataSearch));
    } else {
      yield put(fetchGRListSuccess({}));
    }
  }
}

function* fetchPOReleaseRequest(action) {
  const { data } = action.payload;
  try {
    const response = yield httpGet("purchaseOrders/getPORelease", data);
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchPOReleaseSuccess(response.data));
    }
  } catch (e) {
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(fetchPORelease(data));
    } else {
      yield put(fetchPOReleaseSuccess([]));
    }
  }
}

function* getPOReleaseDetailRequest(action) {
  const { poSapNum, grId } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpGet("purchaseOrders/getPOReleaseDetail", {
      poSapNum: poSapNum,
      grId: grId ? grId : 0,
    });
    if (response.status >= 200 && response.status < 300) {
      yield put(getPOReleaseDetailSuccess(response.data));
    }
    yield put(appLoaded());
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getPOReleaseDetail(poSapNum));
    } else {
      yield put(toastError(`Can't get purchase order detail`));
      yield put(getPOReleaseDetailSuccess(null));
    }
  }
}

function* getGRDetailRequest(action) {
  const { grId, history } = action.payload;
  try {
    yield put(appLoading());
    let username = localStorage.getItem("username").toLowerCase();
    const response = yield httpGet(`goodsservicereceipt/${grId}/detail`);
    if (response.status >= 200 && response.status < 300) {
      let data = response.data;
      if (data.withholdingTaxRate != "amount") {
        data.withholdingTaxRate = Number(
          Number(data.withholdingTaxRate).toFixed(2),
        );
      }
      let prCreater = lower(data.prCreater);
      let prRequester = lower(data.prRequester);
      if (data.status == 9 || data.deleted) {
        yield put(toastError("Document does not exist or document is deleted"));
        history.push(goodsServiceReceiptPath);
      } else {
        if (data.status == 5) {
          if (
            data.sn ||
            prRequester.includes(username) ||
            prCreater.includes(username) ||
            lower(data.requesterUser) == username ||
            lower(data.createdByUser) == username
          ) {
            history.push(goodsServiceReceiptEditPath(data.id));
          } else {
            yield put(getGRDetailSuccess(response.data));
            yield put(appLoaded());
          }
        } else if (data.status == 1) {
          if (
            prRequester.includes(username) ||
            prCreater.includes(username) ||
            lower(data.requesterUser) == username ||
            lower(data.createdByUser) == username
          ) {
            history.push(goodsServiceReceiptEditPath(data.id));
          } else {
            yield put(getGRDetailSuccess(response.data));
            yield put(appLoaded());
          }
        } else if (data.status == 0) {
          if (lower(data.createdByUser) == username) {
            history.push(goodsServiceReceiptEditPath(data.id));
          } else {
            yield put(getGRDetailSuccess(response.data));
            yield put(appLoaded());
          }
        } else {
          yield put(getGRDetailSuccess(response.data));
          yield put(appLoaded());
        }
      }
    }
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getGRDetail(grId, history));
    } else {
      if (e.data) {
        yield put(toastError(e.data.message));
        history.push(goodsServiceReceiptPath);
      }
      yield put(getGRDetailSuccess({}));
    }
  }
}

function* getGRDetailEditRequest(action) {
  const { grId, history } = action.payload;
  try {
    yield put(appLoading());
    let username = localStorage.getItem("username").toLowerCase();
    const response = yield httpGet(`goodsservicereceipt/${grId}/detail`);
    if (response.status >= 200 && response.status < 300) {
      let data = response.data;
      if (data.withholdingTaxRate != "amount") {
        data.withholdingTaxRate = Number(
          Number(data.withholdingTaxRate).toFixed(2),
        );
      }
      if (data.status == 9 || data.deleted) {
        yield put(toastError("Document does not exist or document is deleted"));
        history.push(goodsServiceReceiptPath);
      } else {
        let prCreater = lower(data.prCreater);
        let prRequester = lower(data.prRequester);
        if (data.status == 5) {
          if (
            data.sn ||
            prRequester.includes(username) ||
            prCreater.includes(username) ||
            lower(data.requesterUser) == username ||
            lower(data.createdByUser) == username
          ) {
            yield put(getGRDetailEditSuccess(response.data));
            yield put(appLoaded());
          } else {
            history.push(goodsServiceReceiptDetailPath(data.id));
          }
        } else if (data.status == 1) {
          if (
            prRequester.includes(username) ||
            prCreater.includes(username) ||
            lower(data.requesterUser) == username ||
            lower(data.createdByUser) == username
          ) {
            yield put(getGRDetailEditSuccess(response.data));
            yield put(appLoaded());
          } else {
            history.push(goodsServiceReceiptDetailPath(data.id));
          }
        } else if (data.status == 0) {
          if (lower(data.createdByUser) == username) {
            yield put(getGRDetailEditSuccess(response.data));
            yield put(appLoaded());
          } else {
            history.push(goodsServiceReceiptDetailPath(data.id));
          }
        } else {
          history.push(goodsServiceReceiptDetailPath(data.id));
        }
      }
    }
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getGRDetailEdit(grId, history));
    } else {
      yield put(getGRDetailEditSuccess([]));
    }
  }
}

function* getPMUserListRequest(action) {
  const { grId } = action.payload;
  try {
    yield put(appLoading());
    // const response = yield httpGet('rfqs',param?{...param}:{})
    // if (response.status >= 200 && response.status < 300) {
    //   yield put(getGRDetailSuccess(response.data))
    // }
    yield put(getPMUserListSuccess([]));
    yield put(appLoaded());
  } catch (e) {
    yield put(appLoaded());
    yield put(getPMUserListSuccess([]));
  }
}

function* createGRRequest(action) {
  const { data, history, isSubmit } = action.payload;
  try {
    yield put(appLoading("Save Goods Service Receipt"));
    const response = yield httpPost("goodsservicereceipt", data);
    if (response.status >= 200 && response.status < 300) {
      yield put(
        saveGRAttachments(
          { ...data, id: response.data },
          history,
          isSubmit,
          true,
        ),
      );
    }
    yield put(appLoaded());
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message));
    } else {
      yield put(toastError("Save Goods Service Receipt fail."));
    }
    yield put(appLoaded());
  }
}

function* updateGRRequest(action) {
  const { data, history, isSubmit } = action.payload;
  try {
    yield put(appLoading("Save Goods Service Receipt"));
    const response = yield httpPut(`goodsservicereceipt/${data.id}`, data);
    if (response.status >= 200 && response.status < 300) {
      yield put(saveGRAttachments(data, history, isSubmit, false));
    }
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message));
    } else {
      yield put(toastError("Save Goods Service Receipt fail."));
    }
    yield put(appLoaded());
  }
}

function* saveGRAttachmentsRequest(action) {
  const { data, history, isSubmit, isCreate } = action.payload;
  let fileCount = 0;
  let countUploading = 1;
  let fileName = "";
  try {
    yield put(appLoading("Upload attachments"));
    var attachmentsData = {};
    if (data.gr02) attachmentsData.gr02 = data.gr02;
    if (data.gr03) attachmentsData.gr03 = data.gr03;
    if (data.gr04) attachmentsData.gr04 = data.gr04;
    if (data.gr05) attachmentsData.gr05 = data.gr05;
    if (data.gr06) attachmentsData.gr06 = data.gr06;
    if (data.gr07) attachmentsData.gr07 = data.gr07;
    if (data.gr08) attachmentsData.gr08 = data.gr08;

    Object.keys(attachmentsData).forEach((x) => {
      let object = attachmentsData[x];
      if (Array.isArray(object)) {
        fileCount += object.length;
      }
    });

    let keys = Object.keys(attachmentsData);
    for (let i = 0; i < keys.length; i++) {
      let keyName = keys[i];
      let object = attachmentsData[keyName];
      if (Array.isArray(object)) {
        for (let ii = 0; ii < object.length; ii++) {
          let fileItem = object[ii];
          fileName = fileItem.path;
          yield put(
            appLoading(
              `Uploading File '${fileItem.path}' (${countUploading}/${fileCount})`,
            ),
          );
          let file = {};
          file[keyName] = [fileItem];
          yield httpPost(
            `goodsservicereceipt/${data.id}/Attachments`,
            file,
            multipartHeader,
          );
          countUploading++;
        }
      }
    }

    if (isSubmit) {
      if (data.status == 5) {
        // status reject Resubmit
        yield put(resubmitGR(data, history));
      } else {
        yield put(submitGR(data, history));
      }
    } else {
      yield put(appLoaded());
      history.push(goodsServiceReceiptPath);
      yield put(toastSuccess("Save Goods Service Receipt success."));
    }
  } catch (e) {
    if (isCreate) {
      history.push(goodsServiceReceiptEditPath(data.id));
    }
    yield put(
      toastError(
        `Upload Attachments fail on '${fileName}' (${countUploading}/${fileCount})`,
        true,
      ),
    );
    yield put(appLoaded());
  }
}

function* submitGRRequest(action) {
  const { data, history } = action.payload;
  try {
    yield put(appLoading("Submit Goods Service Receipt"));
    const response = yield httpPost(`goodsservicereceipt/${data.id}/submit`, {
      comment: data.actionComment,
    });
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded());
      history.push(goodsServiceReceiptPath);
      yield put(toastSuccess("Submit Goods Service Receipt success."));
    }
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message));
    } else {
      yield put(toastError("Submit Goods Service Receipt fail."));
    }
    yield put(appLoaded());
  }
}

function* resubmitGRRequest(action) {
  const { data, history } = action.payload;
  try {
    yield put(appLoading("Submit Goods Service Receipt"));
    const response = yield httpPost("goodsservicereceipt/reSubmit", {
      docId: data.id,
      sn: data.sn,
      comment: data.actionComment,
    });
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded());
      history.push(goodsServiceReceiptPath);
      yield put(toastSuccess("Submit Goods Service Receipt success."));
    }
  } catch (e) {
    yield put(toastError("Submit Goods Service Receipt fail."));
    yield put(appLoaded());
  }
}

function* cancelGRRequest(action) {
  const { data, history } = action.payload;
  try {
    yield put(appLoading("Cancel Goods Service Receipt"));
    const response = yield httpDelete(
      `goodsservicereceipt/${data.id}/Cancel`,
      data,
    );
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded());
      history.push(goodsServiceReceiptPath);
      yield put(toastSuccess("Cancel Goods Service Receipt success."));
    }
  } catch (e) {
    yield put(toastError("Cancel Goods Service Receipt fail."));
    yield put(appLoaded());
  }
}

function* deleteGRRequest(action) {
  const { data, history } = action.payload;
  try {
    yield put(appLoading("Delete Goods Service Receipt"));
    const response = yield httpDelete(`goodsservicereceipt/${data.docId}`);
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded());
      history.push(goodsServiceReceiptPath);
      yield put(toastSuccess("Delete Goods Service Receipt success."));
    }
  } catch (e) {
    yield put(toastError("Delete Goods Service Receipt fail."));
    yield put(appLoaded());
  }
}

function* callGRActionRequest(action) {
  const { data, history } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpPost(
      `goodsservicereceipt/${data.docId}/actionApproval`,
      data,
      multipartHeader,
    );
    if (response.status >= 200 && response.status < 300) {
      if (history.location.search.includes("h=true")) {
        yield put(appLoaded());
        history.push(homePath);
      } else {
        yield put(appLoaded());
        history.push(goodsServiceReceiptPath);
      }
      yield put(toastSuccess("Action Goods Service Receipt success."));
    }
  } catch (e) {
    yield put(toastError("Action Goods Service Receipt fail."));
    yield put(appLoaded());
  }
}

function* getGRGOAWorkFlowViewModeRequest(action) {
  const { grId } = action.payload;
  try {
    const response = yield httpGet(
      `goodsservicereceipt/workflowApproverViewMode`,
      { grId: grId },
    );
    if (response.status >= 200 && response.status < 300) {
      yield put(getGRGOAWorkFlowViewModeSuccess(response.data));
    }
  } catch (e) {
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getGRGOAWorkFlowViewMode(grId));
    } else {
      yield put(getGRGOAWorkFlowViewModeSuccess([]));
    }
  }
}

function* getGRGOAWorkFlowEditModeRequest(action) {
  const { data } = action.payload;
  try {
    const response = yield httpGet(
      "goodsservicereceipt/workflowApproverEditMode",
      data,
    );
    if (response.status >= 200 && response.status < 300) {
      yield put(getGRGOAWorkFlowEditModeSuccess(response.data));
    }
  } catch (e) {
    yield put(getGRGOAWorkFlowEditModeSuccess([]));
  }
}

function* getGRErrorWorkFlowRequest(action) {
  const { procInstID, subProcInstID } = action.payload;
  try {
    const response = yield httpGet(`share/workflow/getErrorWorkflow`, {
      procInstID: procInstID,
      subProcInstID: subProcInstID,
    });
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        yield put(getGRErrorWorkFlowSuccess({ isError: false, msg: "" }));
      } else {
        yield put(
          getGRErrorWorkFlowSuccess({
            isError: true,
            msg: response.data.message,
          }),
        );
      }
    }
  } catch (e) {
    yield put(getGRErrorWorkFlowSuccess({ isError: false, msg: "" }));
  }
}

function* checkDuplicateInvoiceRequest(action) {
  const { data, history, isSubmit } = action.payload;
  try {
    yield put(appLoading("Save Goods Service Receipt"));
    const response = yield httpGet(
      `goodsservicereceipt/CheckDuplicateInvoice`,
      { inv: data.invoiceNumber, vendorCode: data.vendorCode },
    );
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        //case duplicate
        yield put(checkDuplicateInvoiceSuccess(response.data));
        yield put(appLoaded());
      } else {
        yield put(checkDuplicateInvoiceSuccess(response.data));
        yield put(createGR(data, history, isSubmit));
      }
    }
  } catch (e) {
    yield put(checkDuplicateInvoiceSuccess(false));
    yield put(toastError("Save Goods Service Receipt fail."));
    yield put(appLoaded());
  }
}

function* getGRReportRequest(action) {
  const { dateS, dateE, companyCode, key } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpGet("goodsservicereceipt/report", {
      dateStart: dateS,
      dateEnd: dateE,
      companyCode: companyCode,
      key: key,
    });
    if (response.status === 200) {
      yield put(appLoaded());
      yield put(getGRReportSuccess(response.data));
    }
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getGRReport(dateS, dateE, companyCode, key));
    } else {
      yield put(toastError("Get report fail"));
    }
  }
}

function* addSpecialCommentRequest(action) {
  const { id, data, history } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpPost(
      `goodsservicereceipt/${id}/comment`,
      data,
      multipartHeader,
    );
    if (response.status === 200) {
      yield put(appLoaded());
      yield put(toastSuccess("Add comment success"));
      yield put(getGRDetail(id, history, true));
    }
  } catch (e) {
    yield put(appLoaded());
    yield put(toastError("Add comment fail"));
  }
}

function* getGRDetailByDocNoRequest(action) {
  const { grId } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpGet(`goodsservicereceipt/${grId}/detail`);
    if (response.status >= 200 && response.status < 300) {
      let data = response.data;
      if (data.withholdingTaxRate != "amount") {
        data.withholdingTaxRate = Number(
          Number(data.withholdingTaxRate).toFixed(2),
        );
      }
      if(data.status != 4){
        yield put(toastError(`Can't cancel this document, Because document ${grId} is ${data.statusName}`));
        yield put(getGRDetailByDocNoSuccess({}));
      }
      else{
      yield put(getGRDetailByDocNoSuccess(response.data));

      }
      yield put(appLoaded());
    }
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(getGRDetailByDocNo(grId));
    } else {
      if (e.data) {
        yield put(toastError(e.data.message));
      }
      yield put(getGRDetailByDocNoSuccess({}));
    }
  }
}

export function* watchGoodsServiceReceiptSaga() {
  yield takeLatest(INITIALIZE_GR, initializeGRRequest);
  yield takeLatest(FETCH_GR.REQUEST, fetchGRListRequest);
  yield takeLatest(FETCH_GR_TYPE.REQUEST, fetchGRTypeRequest);
  yield takeLatest(FETCH_GR_PAYMENT_TYPE.REQUEST, fetchGRPaymentTypeRequest);
  yield takeLatest(FETCH_PO_RELEASE.REQUEST, fetchPOReleaseRequest);
  yield takeEvery(GET_PO_RELEASE_DETAIL.REQUEST, getPOReleaseDetailRequest);
  yield takeLatest(GET_GR_DETAIL.REQUEST, getGRDetailRequest);
  yield takeLatest(GET_GR_DETAIL_EDIT.REQUEST, getGRDetailEditRequest);
  yield takeLatest(GET_PM_USER_LIST.REQUEST, getPMUserListRequest);
  yield takeLatest(CREATE_GR, createGRRequest);
  yield takeLatest(UPDATE_GR, updateGRRequest);
  yield takeLatest(SAVE_GR_ATTACHEMNTS, saveGRAttachmentsRequest);
  yield takeLatest(SUBMIT_GR, submitGRRequest);
  yield takeLatest(RESUBMIT_GR, resubmitGRRequest);
  yield takeLatest(CANCEL_GR, cancelGRRequest);
  yield takeLatest(DELETE_GR, deleteGRRequest);
  yield takeLatest(CALL_GR_ACTION, callGRActionRequest);
  yield takeLatest(
    GET_GR_GOA_WORK_FLOW_VIEW_MODE.REQUEST,
    getGRGOAWorkFlowViewModeRequest,
  );
  yield takeLatest(
    GET_GR_GOA_WORK_FLOW_EDIT_MODE.REQUEST,
    getGRGOAWorkFlowEditModeRequest,
  );
  yield takeLatest(GET_GR_ERROR_WORKFLOW.REQUEST, getGRErrorWorkFlowRequest);
  yield takeLatest(
    GET_SPECIALAPPROVAL_INFO.REQUEST,
    getSpecialApprovalInfoRequest,
  );
  yield takeLatest(
    GR_CHECK_DUPLICATE_INVOICE.REQUEST,
    checkDuplicateInvoiceRequest,
  );
  yield takeLatest(GET_GR_REPORT.REQUEST, getGRReportRequest);
  yield takeLatest(ADD_GR_SPECIAL_COMMENT, addSpecialCommentRequest);
  yield takeLatest(GET_GR_DETAIL_BY_DOCNO.REQUEST, getGRDetailByDocNoRequest);
}

export default createReducer(initial, (state) => ({
  [FETCH_GR.REQUEST]: () => ({
    ...state,
  }),
  [FETCH_GR.SUCCESS]: (data) => ({
    ...state,
    grList: data.data,
  }),
  [FETCH_GR_TYPE.REQUEST]: () => ({
    ...state,
    grType: { data: [], loading: true },
  }),
  [FETCH_GR_TYPE.SUCCESS]: (data) => ({
    ...state,
    grType: { data: data.data, loading: false },
  }),
  [FETCH_GR_PAYMENT_TYPE.REQUEST]: () => ({
    ...state,
    grPaymentType: { data: [], loading: true },
  }),
  [FETCH_GR_PAYMENT_TYPE.SUCCESS]: (data) => ({
    ...state,
    grPaymentType: { data: data.data, loading: false },
  }),
  [FETCH_PO_RELEASE.REQUEST]: () => ({
    ...state,
    poReleaseList: { buffer: [], data: [], loading: true },
  }),
  [FETCH_PO_RELEASE.SUCCESS]: (data) => ({
    ...state,
    poReleaseList: { buffer: data.data, data: data.data, loading: false },
  }),
  // [GET_PO_RELEASE_DETAIL.REQUEST]: () => ({
  //   ...state,
  //   poReleaseDetail: { buffer:[], data: [], loading: true }
  // }),
  [GET_PO_RELEASE_DETAIL.SUCCESS]: (data) => ({
    ...state,
    poReleaseDetail: data.data,
  }),
  [FILTER_ITEM_PO_RELEASE]: (data) => {
    const { poSapNum } = data;
    let clone = JSON.parse(JSON.stringify(state.poReleaseList.buffer));
    let basePOIndex = clone.findIndex((x) => x.sapNumber === poSapNum);
    if (basePOIndex >= 0) {
      let cloneBasePO = JSON.parse(JSON.stringify(clone[basePOIndex]));
      clone.splice(basePOIndex, 1);
      let newPOList = clone.filter(
        (x) =>
          x.companyCode === cloneBasePO.companyCode &&
          x.projectId === cloneBasePO.projectId &&
          x.deliveryName === cloneBasePO.deliveryName &&
          x.deliveryAddress === cloneBasePO.deliveryAddress &&
          x.vendorCode === cloneBasePO.vendorCode &&
          x.goaid === cloneBasePO.goaid &&
          x.specialApprovalId === cloneBasePO.specialApprovalId,
      );
      return {
        ...state,
        poReleaseList: {
          buffer: state.poReleaseList.buffer,
          data: newPOList,
          loading: false,
        },
      };
    } else {
      return {
        ...state,
        poReleaseList: {
          buffer: state.poReleaseList.buffer,
          data: state.poReleaseList.data,
          loading: false,
        },
      };
    }
  },
  [REMOVE_ITEM_PO_RELEASE]: (data) => {
    const { poSapNum } = data;
    let clone = JSON.parse(JSON.stringify(state.poReleaseList.data));
    let basePOIndex = clone.findIndex(
      (x) => x.purchaseOrderSapNumber === poSapNum,
    );
    clone.splice(basePOIndex, 1);
    return {
      ...state,
      poReleaseList: {
        buffer: state.poReleaseList.buffer,
        data: clone,
        loading: false,
      },
    };
  },
  [ADD_ITEM_PO_RELEASE]: (data) => {
    const { poSapNum } = data;
    let clone = JSON.parse(JSON.stringify(state.poReleaseList.buffer));
    let basePOIndex = clone.findIndex(
      (x) => x.purchaseOrderSapNumber === poSapNum,
    );
    let cloneBasePO = JSON.parse(JSON.stringify(clone[basePOIndex]));
    let cloneBaseData = JSON.parse(JSON.stringify(state.poReleaseList.data));
    cloneBaseData.push(cloneBasePO);
    return {
      ...state,
      poReleaseList: {
        buffer: state.poReleaseList.buffer,
        data: cloneBaseData,
        loading: false,
      },
    };
  },
  [RESET_ITEM_PO_RELEASE]: () => {
    let clone = JSON.parse(JSON.stringify(state.poReleaseList.buffer));
    return {
      ...state,
      poReleaseList: { buffer: clone, data: clone, loading: false },
    };
  },
  [GET_GR_DETAIL.REQUEST]: (data) => {
    if (data.isRefresh) {
      return { ...state };
    } else {
      return {
        ...state,
        grDetail: { data: {}, loaded: false },
      };
    }
  },
  [GET_GR_DETAIL.SUCCESS]: (data) => {
    let username = localStorage.getItem("username").toLowerCase();
    let x = data.data;
    if (Object.keys(x).length) {
      if (x.status == 2 && x.requesterUser.toLowerCase() == username) {
        x.canComment = true;
      }
    }
    return {
      ...state,
      grDetail: { data: x, loaded: true },
    };
  },
  [GET_GR_DETAIL_EDIT.REQUEST]: () => ({
    ...state,
    grDetail: { data: {}, loaded: false },
  }),
  [GET_GR_DETAIL_EDIT.SUCCESS]: (data) => ({
    ...state,
    grDetail: { data: data.data, loaded: true },
  }),
  [GET_PM_USER_LIST.REQUEST]: () => ({
    ...state,
    pmUsers: { data: {}, loaded: false },
  }),
  [GET_PM_USER_LIST.SUCCESS]: (data) => ({
    ...state,
    pmUsers: { data: data.data, loaded: true },
  }),
  [CLEAR_GR_DETAIL]: () => ({
    ...state,
    k2workFlowError: { isError: false, msg: "" },
    grDetail: { data: {}, loaded: false },
    poReleaseDetail: null,
    poReleaseList: { buffer: [], data: [], loading: false },
  }),
  [GET_GR_GOA_WORK_FLOW_VIEW_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow: { data: [], loading: true },
  }),
  [GET_GR_GOA_WORK_FLOW_VIEW_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow: { data: data.data, loading: false },
  }),
  [GET_GR_GOA_WORK_FLOW_EDIT_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow: { data: [], loading: true },
  }),
  [GET_GR_GOA_WORK_FLOW_EDIT_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow: { data: data.data, loading: false },
  }),
  [GET_GR_ERROR_WORKFLOW.REQUEST]: () => ({
    ...state,
    k2workFlowError: { isError: false, msg: "" },
  }),
  [GET_GR_ERROR_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    k2workFlowError: { isError: data.data.isError, msg: data.data.msg },
  }),
  [GET_SPECIALAPPROVAL_INFO.REQUEST]: () => ({
    ...state,
    specialApprovalInfo: { data: false, loading: true },
  }),
  [GET_SPECIALAPPROVAL_INFO.SUCCESS]: (data) => ({
    ...state,
    specialApprovalInfo: { data: data.data, loading: false },
  }),
  [GR_CHECK_DUPLICATE_INVOICE.REQUEST]: () => ({
    ...state,
    invDuplicate: null,
  }),
  [GR_CHECK_DUPLICATE_INVOICE.SUCCESS]: (data) => ({
    ...state,
    invDuplicate: data.data,
  }),
  [CLEAR_CHECK_DUPLICATE_INVOICE]: () => ({
    ...state,
    invDuplicate: null,
  }),
  [GET_GR_REPORT.REQUEST]: () => ({
    ...state,
    grReportList: { data: [], loaded: false },
  }),
  [GET_GR_REPORT.SUCCESS]: (data) => ({
    ...state,
    grReportList: { data: data.data, loaded: false },
  }),
  [GET_GR_DETAIL_BY_DOCNO.REQUEST]: (data) => {
    return {
      ...state,
      grDetail: { data: {}, loaded: false },
    };
  },
  [GET_GR_DETAIL_BY_DOCNO.SUCCESS]: (data) => {
    let x = data.data;
    return {
      ...state,
      grDetail: { data: x, loaded: true },
    };
  },
}));
